// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1Lkv5","fullWidth":"Button_fullWidth__2w1mR","primary":"Button_primary__I_9I9","secondary":"Button_secondary__1gv5E","label":"Button_label__2AAHL"};